<style scoped>
    .form-line{
        display: table;
        margin-top: 5px;
        width: 100%;
    }
</style>
<template>
  <div>
    <div class="form-line">
      <Button
        size="small"
        long
        icon="md-add"
        @click="addCondition"
      >
        添加条件
      </Button>
    </div>
    <div class="form-line">
      <table class="mis-table">
        <thead>
          <tr>
            <th>条件类型</th>
            <th>字段名</th>
            <th>操作符</th>
            <th>值</th>
            <th>值类型</th>
            <th>备注</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(condition, index) in edit_item_attrs.conditions"
            :key="condition.id"
          >
            <td>
              <Select
                v-model="condition.condition_type"
                size="small"
                style="width: 85px"
                placeholder="选择类型"
                @on-change="updateCondition(condition)"
              >
                <Option
                  value="model_key"
                  label="模型字段"
                />
                <Option
                  value="user_type"
                  label="员工类型"
                />
              </Select>
            </td>
            <td>
              <i-input
                v-if="condition.condition_type === 'model_key'"
                v-model.trim="condition.model_key"
                size="small"
                @on-blur="updateCondition(condition)"
              />
            </td>
            <td>
              <Select
                v-if="condition.condition_type === 'model_key'"
                v-model="condition.operator"
                size="small"
                style="width: 60px"
                placeholder="选择操作符"
                @on-change="updateCondition(condition)"
              >
                <Option
                  value="=="
                  label="="
                />
                <Option
                  value=">"
                  label=">"
                />
                <Option
                  value=">="
                  label=">="
                />
                <Option
                  value="<"
                  label="<"
                />
                <Option
                  value="<="
                  label="<="
                />
                <Option
                  value="!="
                  label="!="
                />
              </Select>
            </td>
            <td>
              <div v-if="condition.condition_type === 'model_key'">
                <i-input
                  v-model.trim="condition.key_value"
                  size="small"
                  @on-blur="updateCondition(condition)"
                />
              </div>
              <div v-if="condition.condition_type === 'user_type'">
                <Select
                  v-model="condition.key_value"
                  size="small"
                  style="width: 70px"
                  placeholder="选择员工类型"
                  @on-change="updateCondition(condition)"
                >
                  <Option
                    value="formal"
                    label="正式"
                  />
                  <Option
                    value="informal"
                    label="非正式"
                  />
                </Select>
              </div>
            </td>
            <td>
              <Select
                v-if="condition.condition_type === 'model_key'"
                v-model="condition.key_type"
                size="small"
                style="width: 85px"
                placeholder="选择值类型"
                @on-change="updateCondition(condition)"
              >
                <Option value="number">
                  数字
                </Option>
                <Option value="string">
                  字符
                </Option>
                <Option value="bool">
                  布尔
                </Option>
                <Option value="model_key">
                  模型字段
                </Option>
              </Select>
            </td>
            <td>
              <i-input
                v-model.trim="condition.remark"
                type="textarea"
                :rows="2"
                size="small"
                @on-blur="updateCondition(condition)"
              />
            </td>
            <td width="40">
              <Poptip
                placement="left-end"
                confirm
                title="您确认删除吗?"
                transfer
                @on-ok="deleteCondition(condition, index)"
              >
                <span class="delete-condition-btn">
                  <Icon
                    type="md-close"
                    size="16"
                  />
                </span>
              </Poptip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  const key_mapping = {
    FlowNode: 'id',
    FlowEdge: 'edge_id',
    FlowNodeUser: 'id'
  }
  export default {
    props: {
      type: {
        type: String,
        required: true,
        validator: (value) => {
          return ['FlowNode', 'FlowEdge', 'FlowNodeUser'].indexOf(value) > -1;
        }
      },
      edit_item_attrs: {
        type: Object,
        required: true
      },
      //            conditions: {
      //                type: Array,
      //                required: true
      //            }
    },
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      addCondition() {
        // item 为node或edge
        const item = this.edit_item_attrs;
        const key = key_mapping[this.type]
        Util.ajax.get(Util.api.add_flow_condition, {
          params: {
            flow_model_type: this.type,
            flow_model_id: item[key]
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            
            item.conditions.push(data);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Message.error('新建条件失败');
        });
      },
      updateCondition(condition) {
        Util.ajax.post(Util.api.update_flow_condition, condition).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.$Message.success('数据更新成功！')
        }).catch((e) => {
          console.log(e);
          this.$Message.error('保存条件失败');
        });
      },
      deleteCondition(condition, index) {
        const item = this.edit_item_attrs;
        Util.ajax.post(Util.api.delete_flow_condition, {
          id: condition.id,
        }).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          item.conditions.splice(index, 1);
        }).catch((e) => {
          console.log(e);
          this.$Message.error('删除条件失败');
        });
      },
    }
  }
</script>
